// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"74718469","240":"5d7cd80e","284":"3dd84bf6","350":"62f6f895"}[chunkId] + ".css";
};